import React, { Component } from 'react';
import Summary from './summary';
import NewsPager from './newsPager';
import './styles/css/newsList.css';
import Vars from '../config/vars';
class NewsList extends Component { 
  renderItems() {
    if (this.props.data.length === 0) {
      return (
        <p>No News Items</p>
      )
    }
    switch (parseInt(this.props.layout)) {
      case 2: // Alternate title
        return this.props.data.map((item, i) =>
          <li key={i} style={{listStyle:"none",margin:0}}><a tabIndex="0" href={item.node.url}>{item.node.alt_title}</a></li>
        );
      case 3: // Title w Image
        return this.props.data.map((item, i) =>
          <li key={i} style={{listStyle:"none",margin:0}}><a tabIndex="0" href={item.node.url}><img src={item.node.field_image.src} alt={item.node.field_image.alt} /><p>{item.node.title}</p></a></li>
        );
      case 4: // Title w Date and Image
        return this.props.data.map((item, i) =>
          <li key={i} style={{listStyle:"none",margin:0}}><a tabIndex="0" href={item.node.url} style={{border:"none"}}>
            <p className="hover" style={{borderBottom:"1px dashed",fontSize: "1em", margin: "0.75em 0 0",}}>{item.node.field_publish_date}</p>
            <p style={{fontSize: "1.2em", margin:"0 0 0.25em",}}>{item.node.title}</p>
            <img style={{border:"none"}} src={item.node.field_image.src} alt={item.node.field_image.alt} />
          </a></li>
        );
      case 5: // Title, Subhead, Image, summary
        return this.props.data.map((item, i) =>
          <li key={i} className={'item' + i} style={{listStyle:"none",margin:0}}><a tabIndex="0" href={item.node.url}>
            {i === 0?<p><span className="hover watercourse" style={{
              fontWeight: 500,
              borderBottom: "1px dashed",
              lineHeight: "1.5em",
              fontSize: "1.3em",
              fontFamily: "Oswald, sans-serif",   
            }}>{item.node.title}</span></p>:null}
            {item.node.field_subhead && i === 0?<p>{item.node.field_subhead}</p>:null}
            <img src={item.node.field_image.src} alt={item.node.field_image.alt} />
            {i !== 0?<p><span className="hover apple" style={{
              fontWeight: 500,
              fontSize: "1.11111111111em",
              borderBottom: "1px dashed",
              lineHeight: "1.5em",
              textTransform: "uppercase"
            }}>{item.node.title}</span></p>:null}
            <Summary>{item.node.field_summary}</Summary>
            <p style={{clear:"both",textAlign:"right"}}><span style={{fontSize:"0.75em"}}>Full Story</span> &raquo;</p>
          </a></li>
        );
      default: // Title
        return this.props.data.map((item, i) =>
          <li style={{listStyle: "none",margin:0,marginBottom:"1.3em"}} key={i}><a tabIndex="0" href={item.node.url} className="border hover" style={{lineHeight:"1.3em"}}>{item.node.title}</a></li>
        );
    }
  }

  render() {
    return(
      <div style={{margin:"0.5em "+Vars.gutter}} className="newsItems">
        {this.props.title?<h2 style={{ color: "#66ac47", textTransform: "uppercase"}}>{this.props.title}</h2>:null}
        <ul style={{margin:"0", padding:"0"}} className={"display" + this.props.layout}>{this.renderItems()}</ul>
        {Number(this.props.layout) === 5 || this.props.data.length === 0?null:<NewsPager back={this.props.back} prevPage={this.props.prevPage} nextPage={this.props.nextPage} />}        
      </div>
    )
  }
}

export default NewsList;
